/**
 * Identity type constants used throughout the GEAO onboarding process.
 * Defines the two main types of identities that can be onboarded.
 * 
 * @readonly
 * @enum {string}
 */
export default Object.freeze({
    /** Agent identity type for individual agent onboarding */
    Agent: "Agent",
    /** Agency identity type for agency onboarding */
    Agency: "Agency"
});